// extracted by mini-css-extract-plugin
export default {"wrapper":"Forecast_wrapper__JJU+f","card":"Forecast_card__My1C1","forecast":"Forecast_forecast__r1Jsw"};